import { render } from "./GithubSection.vue?vue&type=template&id=4f27eaaa&scoped=true"
import script from "./GithubSection.vue?vue&type=script&lang=js"
export * from "./GithubSection.vue?vue&type=script&lang=js"

import "./GithubSection.vue?vue&type=style&index=0&id=4f27eaaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f27eaaa"]])

export default __exports__